import React from 'react';
import { Loading, Button } from 'tinper-bee'
import PackageListItem from './packageListItem'
import PackageGridItem from './packageGridItem'

const noDataImgSrc = require('../../../images/no-data.png')

class FilteredPackages extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
    }
    seeMDF() {
        this.props.seeMDF && this.props.seeMDF()
    }

    render() {
        const {data = [], showMode, loading} = this.props;
        return (
            <div className='filtered-packages-container'>
                {
                    loading
                        ?
                        <div className='no-data'>
                            <Loading container={this} show={true} />
                        </div>
                        :
                        data.length ? data.map((item) => showMode === 'list' ? <PackageListItem item={item} /> : <PackageGridItem item={item} />)
                            :
                            <div className='no-data'>
                                <div>
                                    <img src={noDataImgSrc} />
                                </div>
                            </div>
                }
            </div>
        );
    }
}

export default FilteredPackages;
